import { SearchBar as SearchBarBase } from '@mint-lib/tw-components/patterns';

import { Separator } from './Separator.jsx';
import { useToolbarState } from './useToolbarState.js';

type SearchBarProps = {
  placeholder?: string;
  disabled?: boolean;
  separator?: boolean;
  /**
   * The search value is stored in this URL query parameter — an empty value
   * removes the param from the URL. Read the value back from the route's
   * search params; there is no change callback.
   *
   * This allows the toolbar state to be bookmarked and restored from the URL.
   *
   * @example
   * // ?q=foo restores the search input with "foo"
   * <SearchBar placeholder="Search..." queryParamKey="q" />
   */
  queryParamKey: string;
};

export function SearchBar({
  placeholder,
  disabled,
  separator,
  queryParamKey,
}: Readonly<SearchBarProps>) {
  const [value, setValue] = useToolbarState<string>('', queryParamKey);

  return (
    <>
      <SearchBarBase
        size="small"
        placeholder={placeholder}
        disabled={disabled}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onClear={() => setValue('')}
        className="order-last w-75"
      />
      {separator && <Separator />}
    </>
  );
}
